import React from "react";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ListingCard from "./ListingCard";
import Paginate from "../../layout/Paginate";
import { products } from "../../../data/products";

const Listing = ({ title }) => {
  return (
    <div className="grow">
      <FilterHeader title={title} />
      <Paginate
        itemsPerPage={5}
        data={products}
        element={(props) => <ListingCard {...props} />}
        containerClassName="flex flex-col gap-4 mt-8"
      />
    </div>
  );
};

export default Listing;
